import { render, staticRenderFns } from "./AddEquipment.vue?vue&type=template&id=5d635992&scoped=true"
import script from "./AddEquipment.vue?vue&type=script&lang=js"
export * from "./AddEquipment.vue?vue&type=script&lang=js"
import style0 from "./AddEquipment.vue?vue&type=style&index=0&id=5d635992&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d635992",
  null
  
)

export default component.exports